<template>
	<c-box :paddings="isMobile ? [56, 24, 56, 24] : [56, 56, 56, 56]">
		<c-typography type="headline4" color="gray700" :font-weight="400" :align="isMobile ? 'center' : 'left'">
			<img
				:src="logoInfo.src | getImageUrl"
				:alt="logoInfo.alt"
				style="max-height: 30px; height: auto"
				class="d-inline-block"
			/>
			<span v-if="isRootImpact || isDongjak" class="edu-partner-notice-left-word">가</span>
			<span v-if="isGreenNewDeal || isKB || isSba" class="edu-partner-notice-left-word">이</span>
			<br v-if="isMobile" />
			<div v-html="logoInfo.content" />
		</c-typography>
	</c-box>
</template>

<script>
import partnerMixin from '../../../../mixins/partnerMixin';
export default {
	name: 'PartnerNoticeLeft',
	mixins: [partnerMixin],
	computed: {
		logoInfo() {
			if (this.isRootImpact) {
				return {
					src: 'rootimpact-color-logo.svg',
					alt: 'rootimpact가 디지털 관련 일자리 취업을 지원합니다.',
					content: '디지털 관련 일자리 취업을 <br class="only-mobile" />지원합니다.',
				};
			} else if (this.isDongjak) {
				return {
					src: 'dongjak-logo.svg',
					alt: 'donjak이 서울시 동작구 청년들의 취업을 지원합니다.',
					content: '서울시 동작구 청년들의 <br/>취업을 지원합니다.',
				};
			} else if (this.isKB) {
				return {
					src: 'kb-logo.svg',
					alt: 'kbstar가 현직자 직무부트캠프와 <br/>함께합니다.',
					content: '현직자 직무부트캠프와 <br/>함께합니다.',
				};
			} else if (this.isSba) {
				return {
					src: 'sba-color.svg',
					alt: '서울산업진흥원이 디지털 관련 일자리 취업을 지원합니다',
					content: '디지털 관련 일자리 취업을<br/>지원합니다.',
				};
			} else if (this.isHanyang) {
				return {
					src: 'hanyang-logo-color.png',
					alt: '한양대학교',
					content: '맞춤형<br />현직자 직무부트캠프<br />(30만원 상당)',
				};
			} else {
				return {
					src: 'green-new-deal-color-logo.svg',
					alt: 'ibk가 그린뉴딜 유망직무 취업을 지원합니다.',
					content: '그린뉴딜 유망직무 <br/>취업을 지원합니다.',
				};
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.edu-partner-notice-left-word {
	display: inline-block;
	transform: translateY(-3px);
}
</style>
